<app-table id="AREA_ACTIONS" [data]="data" [headers]="tableColumns"></app-table>
